<template>
  <div class="reserve-calendar">
    <div class="reserve-form">
      <van-dropdown-menu>
        <van-dropdown-item
          v-model="searchForm.hospitalArea"
          :options="hospitalList"
          @change="onHospitalAreaChange"
        />
        <van-dropdown-item
          v-model="searchForm.important_guest"
          :options="levelList"
          @change="getBookingList"
        />
      </van-dropdown-menu>

    </div>

    <van-calendar
      title="预约日程"
      type="single"
      @select="goDetail"
      @month-show="showInfo"
      :poppable="false"
      :show-confirm="false"
      :formatter="formatter"
    >
      <template #title>
        <div>
          预约日程
        </div>
      </template>

    </van-calendar>

    <!-- <van-popup
      v-model="showPopup"
      closeable
      position="bottom"
      :style="{ height: '55%' }"
    >
      <van-cell
        v-for="item in list"
        :key="item.name"
      >
        {{item.period}} {{item.op}} <span style="color:red;">{{item.type}}</span> <br />
        {{item.name}} {{item.sex}} {{item.age}} <span style="color:red;">{{item.person_flag_name}}</span> <br />
        备注：{{item.desc}}<br />
      </van-cell>
    </van-popup> -->
  </div>
</template>



<script>
// import { Toast } from "vant";
import bookingService from "@/apis/booking/index.js";
import moment from "moment";
import { setStorageExpire, getStorageExpire } from "@/utils/utils.js";
const hospitalArea_key = "WORK_hospitalArea";

export default {
  name: "resinfo",
  data() {
    return {
      searchForm: {
        hospitalAreaStr: "新永门诊部",
        hospitalArea: "10001",
        important_guest: "",
      },
      show: true,
      showPopup: false,
      showTypePicker: false,
      demoEvents: [],
      list: [],
      hospitalList: [
        {
          text: "新永门诊部",
          value: "10001",
        },
        {
          text: "新太门诊部",
          value: "10002",
        },
        {
          text: "健康中心",
          value: "10003",
        },
      ],
      levelList: [
        {
          text: "OABC类",
          value: "",
        },
        {
          text: "OAB类",
          value: "1",
        },
        {
          text: "C类",
          value: "2",
        },
      ],
    };
  },
  created() {
    const hospitalArea = getStorageExpire(hospitalArea_key);
    if (hospitalArea) this.searchForm.hospitalArea = hospitalArea;
    this.getBookingList();
  },
  methods: {
    onHospitalAreaChange(value) {
      setStorageExpire(hospitalArea_key, value);
      this.getBookingList();
    },
    onVisitTypeConfirm() {},
    formatter(day) {
      const month = day.date.getMonth() + 1;
      const date = day.date.getDate();

      // console.log(day);

      for (var i = 0; i < this.demoEvents.length; i++) {
        if (
          month == this.demoEvents[i].month &&
          date == this.demoEvents[i].date
        ) {
          const currentInfo = this.demoEvents[i];
          if (currentInfo.contain_salon == "1") {
            day.topInfo = "沙";
          }
          day.bottomInfo = currentInfo.info.length;
          if (moment(day.date).isSameOrAfter(moment(), "day"))
            day.type = "middle";
          else {
            day.type = "before";
          }
        }
      }

      return day;
    },
    bingDate() {
      this.showInfo(this.$route.query.date);
    },
    showInfo() {},
    goDetail(day) {
      console.log("select:" + day);
      if (moment(day).isBefore(moment(), "day")) return;
      const { searchForm } = this;
      this.$router.push({
        name: "ReserveTable",
        query: {
          date: moment(day).format("YYYY-MM-DD"),
          hospitalArea: searchForm.hospitalArea,
        },
      });
    },
    getList(dayKey) {
      for (var i = 0; i < this.demoEvents.length; i++) {
        if (dayKey == this.demoEvents[i].day) {
          return this.demoEvents[i].info;
        }
      }
    },
    getBookingList() {
      const { searchForm } = this;
      const loading = this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      bookingService
        .getBookingList({
          time_start: moment().startOf("month").format("YYYY-MM-DD"),
          time_end: moment()
            .add(1, "month")
            .endOf("month")
            .format("YYYY-MM-DD"),
          time_point: "",
          booking_types: "",
          campus: searchForm.hospitalArea,
          important_guest: searchForm.important_guest,
        })
        .then(
          (data) => {
            console.log(data);
            this.demoEvents = data.data;
            //设置代入日期
            console.log("set date:" + this.$route.query.date);
            if (this.$route.query.date != undefined)
              this.showInfo(this.$route.query.date);
            loading.close();
          },
          (error) => {
            // 错误处理
            loading.close();
            console.log(error);
          }
        );
    },
  },
};
</script>

<style lang="scss">
.reserve-calendar {
  .note {
    /* background: url("../../assets/bg1.png") no-repeat; */
    background-position: bottom right;
    padding: 30px;
    text-align: center;
  }
  .van-calendar__day--middle::after {
    border-radius: 50px;
    background-color: red;
  }
  .van-calendar__day--middle {
    color: black;
  }
  .van-calendar__bottom-info {
    color: #ee202e;
    font-weight: bold;
    font-size: 16px;
  }
  .van-calendar__day {
    height: 55px;
  }
  .van-calendar__selected-day {
    background-color: #fff;
    color: black;
  }
  .van-calendar__day--before {
    .van-calendar__bottom-info {
      color: #999;
      font-size: 15px;
      font-weight: 300;
    }
  }
  .van-calendar__top-info {
    display: flex;
    justify-content: end;
    padding-right: 10px;

    font-weight: 400;
    font-size: 12px;

    color: rgb(52, 151, 229);
  }

  .van-calendar__day--before {
    .van-calendar__top-info {
      color: #999;
    }
  }
}
</style>